import { defineMessages } from 'react-intl';

export const landingMessages = defineMessages({
    'landing.title': {
        id: 'landing.title',
        defaultMessage: 'Welcome to Calm Health',
        description: 'Title for the landing page.',
    },
    'landing.welcome_description': {
        id: 'landing.welcome_description',
        defaultMessage:
            'Unlock the benefits of Calm Health. We’ll be your guide to a better relationship with your mental and physical health. Your Calm Health account is available to you at no additional cost as part of your health benefits.',
        description:
            'Description for the landing page introducing the app and the benefits.',
    },
    'landing.redesigned.welcome_description': {
        id: 'landing.redesigned.welcome_description',
        defaultMessage:
            'Feel better, one step at a time. Calm Health offers meditation and sleep support, psychologist-designed clinical programs, and guidance to support your mental health goals.',
        description:
            'Description for the redesigned landing page introducing the app and the benefits.',
    },
    'landing.get_to_know_calm_health': {
        id: 'landing.get_to_know_calm_health',
        defaultMessage: 'Get to know Calm Health',
        description:
            'Heading for the parallax section introducing Calm Health content.',
    },
    'landing.get_to_know_calm_health_description': {
        id: 'landing.get_to_know_calm_health_description',
        defaultMessage:
            'Discover all the programs and resources Calm Health has to offer.',
        description:
            'Supporting copy for the parallax section introducing Calm Health content.',
    },
    'landing.meet_calm_health': {
        id: 'landing.meet_calm_health',
        defaultMessage: 'Meet Calm Health',
        description:
            'Button text for the CTA in the parallax section introducing Calm Health content.',
    },
    'landing.get_to_know_calm_health_tile_image': {
        id: 'landing.get_to_know_calm_health_tile_image',
        defaultMessage: 'Calm Health',
        description:
            'Alt text for the Calm Health logo tile in the parallax section introducing Calm Health content.',
    },
    'landing.get_to_know_tile_masterclasses': {
        id: 'landing.get_to_know_tile_masterclasses',
        defaultMessage: 'Masterclasses',
        description:
            'Title overlay for the Masterclasses tile in the decorative collage flanking the "Get to know Calm Health" section.',
    },
    'landing.get_to_know_tile_movement': {
        id: 'landing.get_to_know_tile_movement',
        defaultMessage: 'Movement',
        description:
            'Title overlay for the Movement tile in the decorative collage flanking the "Get to know Calm Health" section.',
    },
    'landing.get_to_know_tile_sleep_stories': {
        id: 'landing.get_to_know_tile_sleep_stories',
        defaultMessage: 'Sleep Stories',
        description:
            'Title overlay for the Sleep Stories tile in the decorative collage flanking the "Get to know Calm Health" section.',
    },
    'landing.get_to_know_tile_clinical_programs': {
        id: 'landing.get_to_know_tile_clinical_programs',
        defaultMessage: 'Clinical Programs',
        description:
            'Title overlay for the Clinical Programs tile in the decorative collage flanking the "Get to know Calm Health" section.',
    },
    'landing.get_to_know_tile_dailies': {
        id: 'landing.get_to_know_tile_dailies',
        defaultMessage: 'Dailies',
        description:
            'Title overlay for the Dailies tile in the decorative collage flanking the "Get to know Calm Health" section.',
    },
    'landing.get_to_know_tile_meditations': {
        id: 'landing.get_to_know_tile_meditations',
        defaultMessage: 'Meditations',
        description:
            'Title overlay for the Meditations tile in the decorative collage flanking the "Get to know Calm Health" section.',
    },
    'landing.get_to_know_tile_best_of_calm': {
        id: 'landing.get_to_know_tile_best_of_calm',
        defaultMessage: 'Best of Calm',
        description:
            'Title overlay for the Best of Calm tile in the decorative collage below the CTA in the "Get to know Calm Health" section.',
    },
    'landing.best_of_calm_title': {
        id: 'landing.best_of_calm_title',
        defaultMessage: 'The best of <calmLogo></calmLogo>',
        description:
            'Heading for the parallax section where the "Best of Calm" tile grows into place beside supporting copy. <calmLogo></calmLogo> is a placeholder swapped for the Calm script logo - translators should move it to wherever the brand name "Calm" belongs in the translated sentence.',
    },
    'landing.best_of_calm_description': {
        id: 'landing.best_of_calm_description',
        defaultMessage:
            'Access meditations, Sleep Stories, dailies, and more to support mindfulness and everyday well-being.',
        description:
            'Supporting copy for the parallax section where the "Best of Calm" tile grows into place beside supporting copy.',
    },
    'landing.evidence_based_programs_title': {
        id: 'landing.evidence_based_programs_title',
        defaultMessage: 'Evidence-based programs',
        description:
            'Heading for the parallax section introducing Calm Health\'s clinical programs, between "Best of Calm" and "Daily activities".',
    },
    'landing.evidence_based_programs_description': {
        id: 'landing.evidence_based_programs_description',
        defaultMessage:
            'Explore psychologist-developed programs designed for a variety of life and health experiences.',
        description:
            "Supporting copy for the parallax section introducing Calm Health's clinical programs.",
    },
    'landing.evidence_based_programs_tile_alt': {
        id: 'landing.evidence_based_programs_tile_alt',
        defaultMessage:
            'Animated cards cycling through example programs and their narrators',
        description:
            "Accessible alt text for the evidence-based programs section's animated SVG tile, which has no visible caption bar overlaid on it and cycles its own baked-in captions per card.",
    },
    'landing.get_to_know_tile_celebrity_sleep_stories': {
        id: 'landing.get_to_know_tile_celebrity_sleep_stories',
        defaultMessage: 'Celebrity Sleep Stories',
        description:
            'Title overlay for the Celebrity Sleep Stories tile in the decorative collage flanking the "Get to know Calm Health" section.',
    },
    'landing.get_to_know_tile_music': {
        id: 'landing.get_to_know_tile_music',
        defaultMessage: 'Music',
        description:
            'Title overlay for the Music tile in the decorative collage flanking the "Get to know Calm Health" section.',
    },
    'landing.get_to_know_tile_mindshift': {
        id: 'landing.get_to_know_tile_mindshift',
        defaultMessage: 'Mindshift',
        description:
            'Title overlay for the Mindshift tile in the decorative collage flanking the "Get to know Calm Health" section.',
    },
    'landing.get_to_know_tile_collections': {
        id: 'landing.get_to_know_tile_collections',
        defaultMessage: 'Collections',
        description:
            'Title overlay for the Collections tile in the decorative collage flanking the "Get to know Calm Health" section.',
    },
    'landing.get_to_know_tile_breathing_exercises': {
        id: 'landing.get_to_know_tile_breathing_exercises',
        defaultMessage: 'Breathing Exercises',
        description:
            'Title overlay for the Breathing Exercises tile in the decorative collage flanking the "Get to know Calm Health" section.',
    },
    'landing.get_to_know_tile_soundscapes': {
        id: 'landing.get_to_know_tile_soundscapes',
        defaultMessage: 'Soundscapes',
        description:
            'Title overlay for the Soundscapes tile in the decorative collage flanking the "Get to know Calm Health" section.',
    },
    'landing.hero_image': {
        id: 'landing.hero_image',
        defaultMessage:
            'Jasper Lake in Jasper National Park, Alberta, Canada, surrounded by snow-capped mountains and lush forests.',
        description: 'Alt text for the hero image on the landing page.',
    },
    'landing.intro_video_fallback_image': {
        id: 'landing.intro_video_fallback_image',
        defaultMessage: 'Mel Mah sitting in a chair.',
        description: 'Alt text for the fallback image for the intro video.',
    },
    'landing.meet_contributors': {
        id: 'landing.meet_contributors',
        defaultMessage: 'Meet our Program Contributors',
        description:
            'Text introducing the contributors to the Calm Health content.',
    },
    'landing.meet_contributors_description': {
        id: 'landing.meet_contributors_description',
        defaultMessage:
            'Calm Health’s programs are written by psychologists and are based on techniques that are proven to work, including cognitive behavioral therapy, acceptance and commitment therapy, and dialectical behavioral therapy.',
        description:
            'Text introducing the expertise of the contributors to the Calm Health content.',
    },
    'landing.meet_narrators': {
        id: 'landing.meet_narrators',
        defaultMessage: 'Meet our Narrators',
        description:
            'Text Introducing the narrators of the Calm Health content.',
    },
    'landing.meet_narrators_description': {
        id: 'landing.meet_narrators_description',
        defaultMessage:
            'Our digital programs are narrated in a friendly, approachable way by the familiar voices of Calm that you know and trust.',
        description:
            'Text describing the style narrators of the Calm Health content.',
    },
    'landing.get_started': {
        id: 'landing.get_started',
        defaultMessage: 'Get Started',
        description: 'Button text to get started with the Calm Health app.',
    },
    'landing.scan_qr_code': {
        id: 'landing.scan_qr_code',
        defaultMessage:
            'Scan the QR code to easily download the Calm Health app.',
        description:
            'Prompt directing the user to download the Calm Health app by using the QR code.',
    },
    'landing.log_in': {
        id: 'landing.log_in',
        defaultMessage: 'Log In',
        description: 'Button text to log in to the Calm Health app.',
    },
    'landing.log_in_full': {
        id: 'landing.log_in_full',
        defaultMessage: 'Log in with your Calm account',
        description:
            'Button text to log in to the Calm Health app through a general Calm acocunt.',
    },
    'landing.sign_in': {
        id: 'landing.sign_in',
        defaultMessage: 'Sign In',
        description: 'Button text to sign in to the Calm Health app.',
    },
    'landing.sign_up': {
        id: 'landing.sign_up',
        defaultMessage: 'Sign Up',
        description: 'Button text to sign up for the Calm Health app.',
    },
    'landing.sign_up_full': {
        id: 'landing.sign_up_full',
        defaultMessage: 'Create a Calm Account',
        description: 'Button text for creating a Calm account.',
    },
    'landing.create_account': {
        id: 'landing.create_account',
        defaultMessage: 'Create Account',
        description: 'Button text for creating a Calm account.',
    },
    'landing.qr_code_alt': {
        id: 'landing.qr_code_alt',
        defaultMessage: 'QR code to download Calm Health',
        description:
            'Alt text for the QR code image, used to download the Calm Health app.',
    },
    'landing.account_sign_in': {
        id: 'landing.account_sign_in',
        defaultMessage: 'Your account sign in:',
        description:
            'Description of the id of the account used for signing in.',
    },
    'landing.apple_id': {
        id: 'landing.apple_id',
        defaultMessage: 'Apple ID',
        description: "Label for the id of the user's Apple account.",
    },
    'landing.google': {
        id: 'landing.google',
        defaultMessage: 'Google',
        description: 'Label for Google login method.',
    },
    'landing.facebook': {
        id: 'landing.facebook',
        defaultMessage: 'Facebook',
        description: 'Label for Facebook login method.',
    },
    'landing.email': {
        id: 'landing.email',
        defaultMessage: 'Email',
        description: 'Label for email (manual) login method.',
    },
    'landing.last_sign_in_method': {
        id: 'landing.last_sign_in_method',
        defaultMessage: 'Your last sign in: {method}',
        description:
            'Shows the login method the user last used, for unauthenticated users.',
    },
    'landing.did_you_know': {
        id: 'landing.did_you_know',
        defaultMessage: 'Did you know?',
        description: 'Text introducing a fact about mental health.',
    },
    'landing.half_of_adults': {
        id: 'landing.half_of_adults',
        defaultMessage: '1 in 2 Adults',
        description: 'Half of all adults.',
    },
    'landing.half_of_adults_description': {
        id: 'landing.half_of_adults_description',
        defaultMessage:
            'Will experience a mental health issue in their lifetime.',
        description: 'Fact about mental health.',
    },
    'landing.half_of_americans': {
        id: 'landing.half_of_americans',
        defaultMessage: '50% of Americans',
        description: 'Half of all Americans.',
    },
    'landing.half_of_americans_description': {
        id: 'landing.half_of_americans_description',
        defaultMessage:
            'Will meet the criteria for a diagnosable mental health condition some time in their life.',
        description: 'Fact about mental health.',
    },
    'landing.depression': {
        id: 'landing.depression',
        defaultMessage: '264 Million',
        description: 'Count of people with depression.',
    },
    'landing.depression_description': {
        id: 'landing.depression_description',
        defaultMessage: 'People suffer from depression worldwide.',
        description: 'Fact about mental health.',
    },
    'landing.mental_health_citation': {
        id: 'landing.mental_health_citation',
        defaultMessage:
            'Mental Health By the Numbers | NAMI: National Alliance on Mental Illness',
        description:
            'Attribution for the facts about mental health on the landing page.',
    },
    'landing.ready_to_improve': {
        id: 'landing.ready_to_improve',
        defaultMessage: 'Ready to prioritize your mental and physical health?',
        description:
            'Question with the goal of getting users to sign up for the Calm Health app.',
    },
    'landing.ready_to_improve_description': {
        id: 'landing.ready_to_improve_description',
        defaultMessage:
            'Taking good care of your mental health has never been more important. Calm Health can help.',
        description:
            'Description of the benefits of using the Calm Health app.',
    },
    'landing.support_your_mental': {
        id: 'landing.support_your_mental',
        defaultMessage: 'Support Your Mental Health',
        description: 'Prompt to get users to sign up for the Calm Health app.',
    },
    'landing.support_your_mental_description': {
        id: 'landing.support_your_mental_description',
        defaultMessage:
            'The Calm Health app offers personalized plans to provide support for a range of health conditions, life experiences, and mental health challenges.',
        description:
            'Descritpion of the programs in the Calm Health app and the situations and benefits they support.',
    },
    'landing.track_your_progress': {
        id: 'landing.track_your_progress',
        defaultMessage: 'Track Your Journey',
        description:
            'Title for the section of the landing page that describes how users can track their progress.',
    },
    'landing.track_your_progress_description': {
        id: 'landing.track_your_progress_description',
        defaultMessage:
            'Calm Health makes it easy to check in, see how you’re doing, and get relevant recommendations for next steps. ',
        description: 'Value of the tracking feature in the Calm Health app.',
    },
    'landing.feel_better': {
        id: 'landing.feel_better',
        defaultMessage: 'Feel Better',
        description:
            'Title for the section of the landing page that describes how users can improve their mood.',
    },
    'landing.feel_better_description': {
        id: 'landing.feel_better_description',
        defaultMessage:
            'Explore Calm Health’s programs at your own pace and learn to better support anxiety and depression symptoms, sleep better and stress less, and make positive changes to your lifestyle.',
        description: 'Description of the benefits of the Calm Health app.',
    },
    'landing.ready_get_started': {
        id: 'landing.ready_get_started',
        defaultMessage: 'Ready to get started?',
        description: 'Propt to get users to sign up for the Calm Health app.',
    },
    'landing.ready_get_started_description': {
        id: 'landing.ready_get_started_description',
        defaultMessage:
            'Download the Calm Health app, create your account, and answer a few simple questions to help us understand how you’re feeling. You’ll get instant recommendations for the Calm Health programs that will be the most helpful for you.\n\nDeveloped by psychologists, you can explore our programs at your own pace, in any order you like. Your personal information will always be kept secure.',
        description:
            'Description of the process of signing up for the Calm Health app.',
    },
    'landing.company': {
        id: 'landing.company',
        defaultMessage: 'Company',
        description: 'Footer link for the Calm company information.',
    },
    'landing.for_health_plans': {
        id: 'landing.for_health_plans',
        defaultMessage: 'For Health Plans',
        description: 'Footer link for the Calm Health app.',
    },
    'landing.for_employers': {
        id: 'landing.for_employers',
        defaultMessage: 'For Employers',
        description: 'Footer link for employer solutions.',
    },
    'landing.for_consultants': {
        id: 'landing.for_consultants',
        defaultMessage: 'For Consultants',
        description: 'Footer link for consultant solutions.',
    },
    'landing.for_organizations_under_300': {
        id: 'landing.for_organizations_under_300',
        defaultMessage: 'For Organizations Under 300',
        description:
            'Footer link for solutions for organizations under 300 employees.',
    },
    'landing.overview': {
        id: 'landing.overview',
        defaultMessage: 'Overview',
        description: 'Footer link for the Calm Health app.',
    },
    'landing.employees_and_payers': {
        id: 'landing.employees_and_payers',
        defaultMessage: 'Employees & Payers',
        description:
            'Footer link for information for insurance employees and payers.',
    },
    'landing.providers': {
        id: 'landing.providers',
        defaultMessage: 'Providers',
        description: 'Footer link for information for insurance providers.',
    },
    'landing.press': {
        id: 'landing.press',
        defaultMessage: 'Press',
        description: 'Footer link for press information.',
    },
    'landing.solutions': {
        id: 'landing.solutions',
        defaultMessage: 'Solutions',
        description: 'Footer section for the Calm Health app solutions.',
    },
    'landing.about_us': {
        id: 'landing.about_us',
        defaultMessage: 'About Us',
        description: 'Footer section for information about Calm Health.',
    },
    'landing.our_experts': {
        id: 'landing.our_experts',
        defaultMessage: 'Our Experts',
        description: 'Footer link for information about Calm Health experts.',
    },
    'landing.support': {
        id: 'landing.support',
        defaultMessage: 'Support',
        description: 'Footer section for Calm Health support links.',
    },
    'landing.admin_login': {
        id: 'landing.admin_login',
        defaultMessage: 'Admin Login',
        description: 'Footer link to the Calm Health admin login.',
    },
    'landing.contact_us': {
        id: 'landing.contact_us',
        defaultMessage: 'Contact Us',
        description: 'Footer link to contact Calm Health.',
    },
    'landing.help_center': {
        id: 'landing.help_center',
        defaultMessage: 'Help Center',
        description: 'Footer link to the Calm Health help center.',
    },
    'landing.ccpa_notice': {
        id: 'landing.ccpa_notice',
        defaultMessage: 'CCPA Notice',
        description: 'Footer link to the CCPA notice for California residents.',
    },
    'landing.calm_health_disclaimer': {
        id: 'landing.calm_health_disclaimer',
        defaultMessage:
            'Calm Health is a mental health wellness product. Calm Health is not intended to diagnose or treat depression, anxiety, or any other disease or condition. Calm Health is not a substitute for care by a physician or other health care provider. Any questions that you may have regarding the diagnosis, care, or treatment of a medical condition should be directed to your physician or health care provider.',
        description:
            'Footer disclaimer text explaining Calm Health is a wellness product and not a substitute for medical care.',
    },
    'landing.calm_business': {
        id: 'landing.calm_business',
        defaultMessage: 'Calm Business',
        description: 'Footer link for the Calm for Business product.',
    },
    'landing.calm_health': {
        id: 'landing.calm_health',
        defaultMessage: 'Calm Health',
        description: 'Footer link for the Calm Health app.',
    },
    'landing.more_information': {
        id: 'landing.more_information',
        defaultMessage: 'More Information',
        description:
            'Footer link for more information about the Calm Health app.',
    },
    'landing.request_information': {
        id: 'landing.request_information',
        defaultMessage: 'Request Information',
        description:
            'Footer link for requesting more information about the Calm Health app.',
    },
    'landing.careers': {
        id: 'landing.careers',
        defaultMessage: 'Careers',
        description: 'Footer link for job opportunities at Calm.',
    },
    'landing.tos': {
        id: 'landing.tos',
        defaultMessage: 'Terms',
        description: 'Footer link for the terms of service.',
    },
    'landing.privacy': {
        id: 'landing.privacy',
        defaultMessage: 'Privacy',
        description: 'Footer link for the privacy policy.',
    },
    'landing.privacy_choices': {
        id: 'landing.privacy_choices',
        defaultMessage: 'Your Privacy Choices',
        description: 'Footer link for privacy choices.',
    },
    'landing.cookies': {
        id: 'landing.cookies',
        defaultMessage: 'Cookies',
        description: 'Footer link for the cookie policy.',
    },
    'landing.consumerHealthData': {
        id: 'landing.consumerHealthData',
        defaultMessage: 'Consumer Health Data',
        description: 'Footer link for consumer health data.',
    },
    'landing.faq': {
        id: 'landing.faq',
        defaultMessage: 'FAQ',
        description: 'Freuently asked questions about the Calm Health app.',
    },
    'landing.resources': {
        id: 'landing.resources',
        defaultMessage: 'Resources',
        description: 'Links to other resources related to the Calm Health app.',
    },
    'landing.linked_in': {
        id: 'landing.linked_in',
        defaultMessage: 'LinkedIn',
        description: 'Footer link to the Calm LinkedIn page.',
    },
    'landing.youtube': {
        id: 'landing.youtube',
        defaultMessage: 'YouTube',
        description: 'Footer link to the Calm YouTube page.',
    },
    'landing.card.anxiety_survival_guide.title': {
        id: 'landing.card.anxiety_survival_guide.title',
        defaultMessage: 'Anxiety Survival Guide',
        description: 'Link to the Anxiety Survival Guide resource.',
    },
    'landing.card.anxiety_survival_guide.image_alt': {
        id: 'landing.card.anxiety_survival_guide.image_alt',
        defaultMessage: 'An image of a person with a cup of tea',
        description:
            'Alt text for the image of the Anxiety Survival Guide resource.',
    },
    'landing.card.better_sleep.title': {
        id: 'landing.card.better_sleep.title',
        defaultMessage: 'Better Sleep',
        description: 'Title for the Better Sleep program.',
    },
    'landing.card.better_sleep.category_title': {
        id: 'landing.card.better_sleep.category_title',
        defaultMessage: 'Masterclass',
        description: 'Label for the category of the Better Sleep program.',
    },
    'landing.card.better_sleep.image_alt': {
        id: 'landing.card.better_sleep.image_alt',
        defaultMessage:
            'A closeup of a smiling person under the covers in a bed',
        description: 'Alt text for the image of the Better Sleep program.',
    },
    'landing.card.navigating_depression.title': {
        id: 'landing.card.navigating_depression.title',
        defaultMessage: 'Navigating Depression with Practical Tools',
        description: 'Program title for Navigating Depression.',
    },
    'landing.card.navigating_depression.image_alt': {
        id: 'landing.card.navigating_depression.image_alt',
        defaultMessage: 'A person walking along a lake',
        description:
            'Alt text for the image of the Navigating Depression program.',
    },
    'landing.card.night_train.title': {
        id: 'landing.card.night_train.title',
        defaultMessage: 'The Nordland Night Train',
        description: 'Title for the Night Train Sleep Story.',
    },
    'landing.card.night_train.category_title': {
        id: 'landing.card.night_train.category_title',
        defaultMessage: 'Sleep Story',
        description: 'Category for the Night Train Sleep Story.',
    },
    'landing.card.night_train.image_alt': {
        id: 'landing.card.night_train.image_alt',
        defaultMessage: 'An image of a train track going off into the dusk.',
        description: 'Alt text for the image of the Night Train Sleep Story.',
    },
    'landing.card.reduce_stress.title': {
        id: 'landing.card.reduce_stress.title',
        defaultMessage: 'Reduce your stress with CSBR',
        description:
            'Title introducig how the user can use the CSBR program to reduce stress.',
    },
    'landing.card.reduce_stress.image_alt': {
        id: 'landing.card.reduce_stress.image_alt',
        defaultMessage: 'An image of a person closing their eyes in a field',
        description: 'Alt text for the image of the CSBR program.',
    },
    'landing.card.reboot.title': {
        id: 'landing.card.reboot.title',
        defaultMessage: '60 Second Reboot',
        description:
            'Card title for the short meditation program to bring users back to a relaxed state.',
    },
    'landing.card.reboot.category_title': {
        id: 'landing.card.reboot.category_title',
        defaultMessage: 'Meditation',
        description: 'Category for the 60 Second Reboot program.',
    },
    'landing.card.reboot.image_alt': {
        id: 'landing.card.reboot.image_alt',
        defaultMessage: 'An image of a person looking at a computer',
        description: 'Alt text for the image of the 60 Second Reboot program.',
    },
    'landing.survey_results': {
        id: 'landing.survey_results',
        defaultMessage:
            "Two sliding scales show the results for Anxiety and Depression. The anxiety score is a 'Minimal' score of 1 and the depression score is a 'Minimal' score of 3.",
        description: 'Description of how the survey results are displayed.',
    },
    'landing.depression_graph': {
        id: 'landing.depression_graph',
        defaultMessage:
            "A graph showing the results of depression screenings 5-10 and possible scores from 0-27. The current score is a 'Moderate' score of 13.",
        description:
            'Description of the graph showing the results of the depression screening.',
    },
    'landing.app_feature_program': {
        id: 'landing.app_feature_program',
        defaultMessage:
            "A screenshot of the Calm Health mobile app 'Preparing for Therapy' program.",
        description:
            'Alt text for the image of the Preparing for Therapy program.',
    },
    'landing.app_feature_player': {
        id: 'landing.app_feature_player',
        defaultMessage:
            "A screenshot of the Calm Health mobile app 'Is Therapy Right For Me?' session player.",
        description:
            'Alt text for the image of the Is Therapy Right For Me? session player.',
    },
    'landing.registration_completed': {
        id: 'landing.registration_completed',
        defaultMessage: 'Your registration has been successfully completed.',
        description:
            'Text confirming that the user has successfully registered for the Calm Health app.',
    },
    'landing.registration_completed_description': {
        id: 'landing.registration_completed_description',
        defaultMessage:
            'Now you can get started by downloading the Calm Health app and logging in to the account you just created.',
        description:
            'Description of the next steps after registering for the Calm Health app.',
    },
    'landing.what_happens_next': {
        id: 'landing.what_happens_next',
        defaultMessage: 'What to expect next',
        description:
            'Title for the section that describes what happens after the user registers for the Calm Health app.',
    },
    'landing.what_happens_next_description': {
        id: 'landing.what_happens_next_description',
        defaultMessage: 'When you download the app, you can:',
        description:
            'Title for the section describing what you can do with the Calm Health app.',
    },
    'landing.track_progress': {
        id: 'landing.track_progress',
        defaultMessage: 'Track Your Progress',
        description:
            'Description of the feature that allows users to track their progress in the Calm Health app.',
    },
    'landing.customized_recommendations': {
        id: 'landing.customized_recommendations',
        defaultMessage: 'Get Customized Recommendations',
        description:
            'Description of the feature that provides personalized recommendations in the Calm Health app.',
    },
    'landing.clinical_programs': {
        id: 'landing.clinical_programs',
        defaultMessage: 'Join Clinical Programs Created by Experts',
        description:
            'Description of how users can join programs within the Calm Health app.',
    },
    'landing.mindfulness': {
        id: 'landing.mindfulness',
        defaultMessage: 'Begin a Mindfulness Practice',
        description:
            'Description of how users can start a mindfulness practice in the Calm Health app.',
    },
    'landing.setup_web': {
        id: 'landing.setup_web',
        defaultMessage:
            'You may also set up your account on your computer and take the mental health screening. Your Plan will be ready when you log in',
        description:
            'Section for users who want to set up their account on a computer.',
    },
    'landing.pause_intro_video': {
        id: 'landing.pause_intro_video',
        defaultMessage: 'Pause intro video',
        description: 'Button to pause the intro video on the landing page.',
    },
    'landing.resume_intro_video': {
        id: 'landing.resume_intro_video',
        defaultMessage: 'Resume intro video',
        description:
            'Button text to resume the intro video on the landing page.',
    },
    'landing.pause_background_video': {
        id: 'landing.pause_background_video',
        defaultMessage: 'Pause background video',
        description:
            'Button to pause the hero background video on the redesigned landing page.',
    },
    'landing.resume_background_video': {
        id: 'landing.resume_background_video',
        defaultMessage: 'Resume background video',
        description:
            'Button to resume the hero background video on the redesigned landing page.',
    },
    'landing.get_the_app': {
        id: 'landing.get_the_app',
        defaultMessage: 'Get The App',
        description:
            'CTA button on the redesigned landing page that opens the app-download dialog.',
    },
    'landing.scroll_to_next_section': {
        id: 'landing.scroll_to_next_section',
        defaultMessage: 'Scroll to next section',
        description:
            'Accessible label for the scroll-indicator button on the redesigned landing page hero.',
    },
    'landing.scroll_to_explore': {
        id: 'landing.scroll_to_explore',
        defaultMessage: 'Scroll to explore',
        description:
            'Tooltip label that appears above the scroll-indicator button on the redesigned landing page hero.',
    },
    'landing.private_and_secure': {
        id: 'landing.private_and_secure',
        defaultMessage: 'Private and Secure',
        description:
            'Heading for the section of the redesigned landing page describing Calm Health’s privacy and security compliance.',
    },
    'landing.private_and_secure_description': {
        id: 'landing.private_and_secure_description',
        defaultMessage:
            'Calm Health complies with HIPAA privacy standards and HITRUST security regulations.',
        description:
            'Description of Calm Health’s privacy and security compliance on the redesigned landing page.',
    },
    'landing.get_calm_health_mobile_app': {
        id: 'landing.get_calm_health_mobile_app',
        defaultMessage: 'Get the Calm Health mobile app',
        description:
            'Title for the QR code banner prompting users to download the Calm Health mobile app on the redesigned landing page.',
    },
    'landing.get_calm_health_mobile_app_card_title': {
        id: 'landing.get_calm_health_mobile_app_card_title',
        defaultMessage: 'Get the Calm Health Mobile App',
        description:
            'Title for the app store download card shown in place of the QR code on small screens on the redesigned landing page.',
    },
    'landing.ready_get_started_summary': {
        id: 'landing.ready_get_started_summary',
        defaultMessage:
            'Download the Calm Health app, create your account, and answer a few simple questions to help us understand how you’re feeling. You’ll get instant recommendations for the Calm Health programs that will be the most helpful for you.',
        description:
            'Short description of the process of signing up for the Calm Health app, used on the redesigned landing page.',
    },
    'landing.app_screenshot_home': {
        id: 'landing.app_screenshot_home',
        defaultMessage:
            "A screenshot of the Calm Health mobile app home screen, recommending the 'Build Stress Resilience' program.",
        description:
            'Alt text for the app home screen screenshot on the redesigned landing page.',
    },
    'landing.app_screenshot_activities': {
        id: 'landing.app_screenshot_activities',
        defaultMessage:
            "A screenshot of the Calm Health mobile app 'Today's Activities' checklist screen.",
        description:
            'Alt text for the app activities screen screenshot on the redesigned landing page.',
    },
    'landing.daily_activities_title': {
        id: 'landing.daily_activities_title',
        defaultMessage: 'Daily activities',
        description:
            'Heading for the parallax section listing Calm Health daily activities on the redesigned landing page.',
    },
    'landing.daily_activities_description': {
        id: 'landing.daily_activities_description',
        defaultMessage:
            'Build healthy habits with simple, daily activities created to fit into your routine.',
        description:
            'Supporting copy for the parallax section listing Calm Health daily activities on the redesigned landing page.',
    },
    'landing.daily_activities_lotus_text': {
        id: 'landing.daily_activities_lotus_text',
        defaultMessage:
            'List your top 3 priorities before starting work to sharpen focus.',
        description:
            'Quote shown for the "Resetting the Nervous System" daily activity callout on the redesigned landing page.',
    },
    'landing.daily_activities_lotus_category': {
        id: 'landing.daily_activities_lotus_category',
        defaultMessage: 'Resetting the Nervous System',
        description:
            'Category label for the "Resetting the Nervous System" daily activity callout on the redesigned landing page.',
    },
    'landing.daily_activities_rocks_text': {
        id: 'landing.daily_activities_rocks_text',
        defaultMessage:
            'Visualize a peaceful scene to help your brain fully recharge.',
        description:
            'Quote shown for the "Boundaries and Balance" daily activity callout on the redesigned landing page.',
    },
    'landing.daily_activities_rocks_category': {
        id: 'landing.daily_activities_rocks_category',
        defaultMessage: 'Boundaries and Balance',
        description:
            'Category label for the "Boundaries and Balance" daily activity callout on the redesigned landing page.',
    },
    'landing.daily_activities_leaf_text': {
        id: 'landing.daily_activities_leaf_text',
        defaultMessage: 'Feel your feet on the ground.',
        description:
            'Quote shown for the "Develop Gratitude" daily activity callout on the redesigned landing page.',
    },
    'landing.daily_activities_leaf_category': {
        id: 'landing.daily_activities_leaf_category',
        defaultMessage: 'Develop Gratitude',
        description:
            'Category label for the "Develop Gratitude" daily activity callout on the redesigned landing page.',
    },
    'landing.personalized_screenings_title': {
        id: 'landing.personalized_screenings_title',
        defaultMessage: 'Personalized screenings',
        description:
            "Heading for the parallax section introducing Calm Health's screenings, on the redesigned landing page.",
    },
    'landing.personalized_screenings_description': {
        id: 'landing.personalized_screenings_description',
        defaultMessage:
            'Take short screenings that help tailor your Calm Health experience.',
        description:
            "Supporting copy for the parallax section introducing Calm Health's screenings.",
    },
    'landing.tailored_recommendations_title': {
        id: 'landing.tailored_recommendations_title',
        defaultMessage: 'Tailored recommendations',
        description:
            'Heading for the parallax section showing tailored recommendation tiles, the last section on the redesigned landing page.',
    },
    'landing.personalized_recommendations_description': {
        id: 'landing.personalized_recommendations_description',
        defaultMessage:
            'Discover relevant resources based on your needs and goals.',
        description:
            'Supporting copy for the parallax section showing personalized recommendation tiles.',
    },
    'landing.personalized_recommendations_tile_breathing_title': {
        id: 'landing.personalized_recommendations_tile_breathing_title',
        defaultMessage: 'Softening Stress and Anxiety',
        description:
            'Title overlay for the breathing exercise tile in the "Personalized recommendations" parallax section.',
    },
    'landing.personalized_recommendations_tile_breathing_subtitle': {
        id: 'landing.personalized_recommendations_tile_breathing_subtitle',
        defaultMessage: 'Breathing Exercise',
        description:
            'Subtitle overlay (the content category) for the breathing exercise tile in the "Personalized recommendations" parallax section.',
    },
    'landing.personalized_recommendations_tile_sleep_story_title': {
        id: 'landing.personalized_recommendations_tile_sleep_story_title',
        defaultMessage: 'Wonder of the Northern Lights',
        description:
            'Title overlay for the Sleep Story tile in the "Personalized recommendations" parallax section.',
    },
    'landing.personalized_recommendations_tile_sleep_story_subtitle': {
        id: 'landing.personalized_recommendations_tile_sleep_story_subtitle',
        defaultMessage: 'Sleep Story',
        description:
            'Subtitle overlay (the content category) for the Sleep Story tile in the "Personalized recommendations" parallax section.',
    },
    'landing.personalized_recommendations_tile_mindshift_title': {
        id: 'landing.personalized_recommendations_tile_mindshift_title',
        defaultMessage: 'Awakened Awareness',
        description:
            'Title overlay for the Mindshift tile in the "Personalized recommendations" parallax section.',
    },
    'landing.personalized_recommendations_tile_mindshift_subtitle': {
        id: 'landing.personalized_recommendations_tile_mindshift_subtitle',
        defaultMessage: 'Mindshift',
        description:
            'Subtitle overlay (the content category) for the Mindshift tile in the "Personalized recommendations" parallax section.',
    },
    'landing.personalized_recommendations_tile_clinical_title': {
        id: 'landing.personalized_recommendations_tile_clinical_title',
        defaultMessage: 'Anxiety Survival Guide',
        description:
            'Title overlay for the clinical program tile in the "Personalized recommendations" parallax section.',
    },
    'landing.personalized_recommendations_tile_clinical_subtitle': {
        id: 'landing.personalized_recommendations_tile_clinical_subtitle',
        defaultMessage: 'Clinical Program',
        description:
            'Subtitle overlay (the content category) for the clinical program tile in the "Personalized recommendations" parallax section.',
    },
});

export default landingMessages;
